import styled from "styled-components";

export const Container = styled.main`
    margin-left: var(--sidebar-width);
    padding-top: 4rem;

`